import Link from '@components/common/Link/Link'
import FishLogo from '@components/icons/FishLogo'
import Button from '@components/ui/ButtonV2/Button'
import Number from '@components/ui/Number/Number'
import { useCart } from '@features/cart/api/get-cart'
import { formatPriceV2 } from '@lib/format-price'
import { selectAlpha2Code, selectLabels } from '@redux/globalSlice'
import { mapEdgesToItems } from '@utils/map'
import clsx from 'clsx'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import CartItem from '../CartItem/CartItem'
import navbarStyles from '../Navbar.module.scss'
import s from './Cart.module.scss'
export interface CartProps {
  shoppingCartLabel?: string
  checkoutButtonLabel?: string
}

const Cart: FC<CartProps> = ({
  shoppingCartLabel = 'Shopping Cart',
  checkoutButtonLabel = 'Checkout',
}) => {
  const [loading, setLoading] = useState(false)
  const labels = useSelector(selectLabels)
  const alpha2Code = useSelector(selectAlpha2Code)

  const { data: cart } = useCart()

  const lineItems = mapEdgesToItems(cart?.lineItems) ?? []
  return (
    <form className={s.root}>
      <div className={s.content}>
        <div className={s.checkoutSection}></div>
        <div className={s.cartItemsSection}>
          {cart?.lineItemsQuantity > 0 ? (
            <>
              <h2 className={clsx(s.cartItemsHeader, navbarStyles.flyoutItem)}>
                YOU HAVE {cart?.lineItemsQuantity}{' '}
                {cart?.lineItemsQuantity > 1 ? 'ITEMS' : 'ITEM'} IN YOUR CART
              </h2>
              <ul className={s.cartItemsList}>
                {cart &&
                  lineItems.map((line) => {
                    return (
                      <CartItem
                        key={line.id}
                        line={line}
                        className={navbarStyles.flyoutItem}
                      />
                    )
                  })}
              </ul>
              {cart && lineItems.length > 0 && (
                <div className={clsx(s.cartCheckout, navbarStyles.flyoutItem)}>
                  <div className={s.cartTotalContainer}>
                    <div className={s.cartTotalHeadings}>
                      <span className={s.cartTotalSumHeading}>
                        {labels.basketTotalSum}
                      </span>
                      <span className={s.cartTotalSumSubhading}>
                        {labels.basketTotalSumSubheading}
                      </span>
                    </div>
                    <Number>{formatPriceV2(alpha2Code, cart.total, 2)}</Number>
                  </div>
                  <div className={s.cartCheckoutBtnWrapper}>
                    <Button
                      type="button"
                      variant="secondary"
                      className={s.cartCheckoutBtn}
                      loading={loading}
                      as={Link}
                      link={{ url: '/cart' }}
                    >
                      {labels.basketCheckoutBtn}
                    </Button>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className={clsx(s.emptyCartBox, navbarStyles.flyoutItem)}>
              <FishLogo width={50} height={50} />
              <h3 className={s.emptyCartHeading}>{labels?.emptyCartLabel}</h3>
              <Button variant="secondary" as={Link} link={labels?.emptyCartCTA}>
                {labels?.emptyCartCTA?.name}
              </Button>
            </div>
          )}
        </div>
      </div>
    </form>
  )
}

export default Cart
